"use strict";

exports.__esModule = true;
exports["default"] = LinkOut;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function LinkOut(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.163 4.893l-15.52 15.519c-.54.551-1.468.506-2.007-.049-.54-.553-.491-1.41.049-1.96L27.2 2.886l-8.52-.009c-.766-.002-1.384-.636-1.384-1.419.002-.785.618-1.414 1.388-1.414l11.865.011a1.444 1.444 0 0 1 .977.417c.129.134.228.292.299.468.071.172.103.357.112.535l-.004 12.211c.004.395-.152.752-.402 1.008a1.332 1.332 0 0 1-.986.408c-.763.002-1.383-.633-1.383-1.419l.001-8.79zM12.686 25.37a6.058 6.058 0 0 1-4.32-1.818c-2.271-2.335-2.244-5.997.051-8.344l7.994-7.994-14.065.001A2.29 2.29 0 0 0 .063 9.499v20.173a2.291 2.291 0 0 0 2.284 2.284h20.175a2.29 2.29 0 0 0 2.284-2.284l-.001-13.96-7.932 7.929c-1.078 1.104-2.576 1.729-4.187 1.729z"
  }));
}